import { motion } from "framer-motion";
import { useState, useEffect } from "react";

const steps = [
  "Choose your course & destination",
  "Submit basic documents",
  "We apply for you — no fees!",
  "Get your offer letter & visa",
];

export default function StudyJourneyPath() {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % steps.length);
    }, 1600);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-white py-28">
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-24">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#253E90]">
            Study Abroad in 2026
          </h2>
          <p className="mt-3 text-gray-500">
            Your step-by-step global education journey
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">

          {/* Desktop Line */}
          <div className="hidden md:block absolute top-10 left-0 right-0 h-[3px] bg-[#253E90]/20 rounded-full" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-16 md:gap-6">

            {steps.map((step, index) => {
              const isActive = index === activeStep;

              return (
                <div key={index} className="relative flex flex-col items-center text-center">

                  {/* Node */}
                  <motion.div
                    animate={
                      isActive
                        ? { scale: 1.15, boxShadow: "0 0 40px rgba(59,130,246,0.9)" }
                        : { scale: 1, boxShadow: "none" }
                    }
                    transition={{ duration: 0.5 }}
                    className="relative z-10 w-20 h-20 rounded-full bg-white border-4 border-[#253E90] flex items-center justify-center"
                  >
                    <span className="text-[#253E90] font-extrabold text-xl">
                      {index + 1}
                    </span>

                    {/* Pulse */}
                    {isActive && (
                      <motion.div
                        animate={{ scale: [1, 1.8], opacity: [0.5, 0] }}
                        transition={{ duration: 1.5, repeat: Infinity }}
                        className="absolute inset-0 rounded-full border-2 border-blue-400"
                      />
                    )}
                  </motion.div>

                  {/* Card */}
                {/* Step Card */}
<motion.div
  animate={
    isActive
      ? {
          y: -6,
          borderColor: "#3B82F6",
          boxShadow: "0 20px 40px rgba(59,130,246,0.35)",
        }
      : {
          y: 0,
          borderColor: "rgba(37,62,144,0.2)",
          boxShadow: "0 10px 20px rgba(0,0,0,0.08)",
        }
  }
  transition={{ duration: 0.45, ease: "easeInOut" }}
  className="
    mt-8 
    bg-white 
    border-2 
    rounded-2xl 
    px-6 
    py-5 
    w-[260px] 
    h-[120px] 
    flex 
    items-center 
    justify-center 
    text-center
  "
>
  <p
    className={`font-medium leading-relaxed ${
      isActive ? "text-[#253E90]" : "text-gray-700"
    }`}
  >
    {step}
  </p>
</motion.div>


                </div>
              );
            })}

          </div>
        </div>
      </div>
    </section>
  );
}
